import { render, staticRenderFns } from "./BlogEdit.vue?vue&type=template&id=3294cbb1&scoped=true&"
import script from "./BlogEdit.vue?vue&type=script&lang=js&"
export * from "./BlogEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3294cbb1",
  null
  
)

export default component.exports